import { Button, TextField } from '@mui/material';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from 'context/AppContext';
import { toast } from 'react-toastify';
import {
  auditColumnDefs,
  columnDefs as gridcolDef,
  defaultDisableButtonsObject,
  fields,
  status as questionStatuses,
  status_colors
} from '../constants/QuestionBankConstants';
import {
  apiPaths,
  deleteData,
  get, postData
} from '../platform-components/api-integration-util';
import ChartCard from '../platform-components/ChartCard';
import Grid from '../platform-components/grid/Grid';
import { PreLoader } from '../platform-components/PreLoader';
import { Toaster } from '../platform-components/Toaster';
import { setItemToStorage } from '../platform-components/utils/common-utils';
import {
  checkPermission,
  setEditQuestion
} from '../platform-components/utils/configuration';
import {
  getRoleNameList, setclickedParamsForAudit
} from '../platform-components/utils/shared-data.service';
import { filterBySubjectScope } from '../platform-components/utils/subject-scope';
import { setQuestionIds } from './Dashboard-Service';
import './dashboard.scss';

function Dashboard(props) {
  const { subjects } = useContext(AppContext);
  let [chartsData, setChartsData] = useState({});
  let [displayCharts, setDisplayCharts] = useState(false);
  let [selectedNodes, setSelectedNodes] = useState([]);
  let [displayAudit, setDisplayAudit] = useState(false);
  let [displayComments, setDisplayComments] = useState(false);
  let comments;
  // let gridOptions = {};
  let gridApi = useRef();
  let status = useRef();
  let auditGridApi = useRef();
  let [loading, setLoading] = useState(true);
  let [gridOptions, setGridOptions] = useState({});
  let [auditGridOptions, setAuditGridOptions] = useState({});
  let [disableButtons, setDisableButtons] = useState(
    JSON.parse(JSON.stringify(defaultDisableButtonsObject))
  );
  let [displayErroMessagePopup, setDisplayErroMessagePopup] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // Column filter state
  const [filterSubject, setFilterSubject] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterComplexity, setFilterComplexity] = useState('');
  const [filterUpdatedBy, setFilterUpdatedBy] = useState('');
  const [filterSearchText, setFilterSearchText] = useState('');
  const filterDebounceRef = useRef(null);

  const [selectedStatuses, setSelectedStatuses] = useState(
    () =>
      JSON.parse(localStorage.getItem('selectedStatuses')) ||
      Object.keys(questionStatuses)
        .map((el) => el)
        .filter((fl) => fl !== 'APPROVED') || []
  );

  const handleStatusClick = (status) => {
    if (selectedStatuses.includes(status)) {
      // unselect the status if it's already selected
      setSelectedStatuses(
        selectedStatuses.filter(
          (selectedStatus) => selectedStatus !== status
        )
      );
    } else {
      // select the status if it's not already selected
      setSelectedStatuses([...selectedStatuses, status]);
    }
  };

  useEffect(() => {
    localStorage.setItem('selectedStatuses', JSON.stringify(selectedStatuses));
  }, [selectedStatuses]);


  const link = (params) => {
    return (
      <div className='text-link' onClick={() => nav(params?.value, params)}>
        {params?.value}
      </div>
    );
  };
  const onAuditClick = (questionId, tenantId, params) => {
    setclickedParamsForAudit(params);

    get(apiPaths.questionstatusaudit, { questionId, tenantId })
      .then((res) => {
        if (res?.result) {
          Toaster(toast.TYPE.SUCCESS, 'Audit Retrieved Successfully');
          auditGridOptions.columnDefs = auditColumnDefs;
          res.result.sort((e1, e2) => e2.auditId - e1.auditId);
          auditGridOptions.rowData = res?.result;
          auditGridOptions.paginationPageSize = 20;
          auditGridOptions.pagination = true;
          auditGridOptions.domLayout = '';
          auditGridOptions.onGridReady = (params) => {
            auditGridApi.current = params.api;
          };
          setTimeout(() => auditGridApi?.current?.setRowData(res?.result));
          setDisplayAudit(true);
        }
      })
      .catch((ele) => {
        Toaster(toast.TYPE.SUCCESS, 'Error while retrieving audit data');
      });

  };
  const button = (params) => {
    return (
      <div
        onClick={() => {
          setDisplayComments(false);
          onAuditClick(params?.data.questionId, params.data.tenantId, params);
        }}
      >
        <button
          data-toggle='modal'
          data-target='#myModal'
          type='button'
          value='Audit'
          style={{ 'margin-right': '10px' }}
        >
          Audit
        </button>
      </div>
    );
  };
  useEffect(() => {
    getDashboardGraphData();
    setItemToStorage('qbData', {})
  }, []);

  const prepareChrtObj = (res, name) => {
    const chartData = res.map(item => ({
      name: item.name || 'No Value',
      count: item.count || 0,
    }));
    setChartsData((prev) => ({ ...prev, [name]: chartData }));
  };
  const onAuditClose = () => {
    setDisplayAudit(false);
  };

  const getDashboardGraphData = () => {
    // let requestparam = {admin: false};
    let requestparam = {};
    let role = getRoleNameList();
    // if (role === 'Admin') {
    //   requestparam.admin = true;
    // }
    setDisplayCharts(false);
    postData(apiPaths.dashboardGraph, { data: [], params: requestparam })
      .then((data) => {
        if (data.result && data.result.viewByStatus) {
          prepareChrtObj(data.result.viewByStatus, 'Status');
        }
        // if(data.result && data.result.viewBySubject) {
        //   prepareChrtObj(data.result.viewBySubject, 'Subject');
        // }
        if (data.result && data.result.viewByUpdatedBy) {
          prepareChrtObj(data.result.viewByUpdatedBy, 'Updated By');
        }
        if (data.result && data.result.viewByComplexity) {
          prepareChrtObj(data.result.viewByComplexity, 'Complexity');
        }
        if (data.result && data.result.viewByCreatedBy) {
          prepareChrtObj(data.result.viewByCreatedBy, 'Created By');
        }

        setTimeout(() => {
          let len = Object.getOwnPropertyNames(chartsData).length;
          let expectedLen = checkPermission('Question Bank', 'View All Questions') || role.includes('Admin') ? 1 : 3;
          if (len >= expectedLen) {
          }

        });
      });
  }

  const mapStatuses = (statuses) => {
    return statuses.map((el) => {
      if (el === 'SENT_FOR_APPROVAL') return 'SENT FOR APPROVAL';
      if (el === 'CORRECTION_NEEDED') return 'NEED CORRECTION';
      return el;
    });
  };

  const getQuestions = useCallback((page = currentPage, size = pageSize) => {
    const requestBody = {
      statuses: mapStatuses(selectedStatuses),
      page: page,
      pageSize: size,
      sortBy: 'question_id',
      sortOrder: 'DESC',
    };
    if (filterSubject) requestBody.subjectId = parseInt(filterSubject);
    if (filterStatus) requestBody.questionStatus = filterStatus;
    if (filterComplexity) requestBody.questionComplexity = filterComplexity;
    if (filterUpdatedBy) requestBody.updatedBy = filterUpdatedBy;
    if (filterSearchText) requestBody.searchText = filterSearchText;

    postData(apiPaths.questionslistPaginated, {
      data: requestBody,
      params: {},
    })
      .then((res) => {
        const paginatedResult = res?.result || {};
        let rowData = filterBySubjectScope(
          paginatedResult.data || [],
          (q) => q.subjectId ?? q.subject_id
        );

        setTotalRecords(paginatedResult.totalRecords || 0);
        setTotalPages(paginatedResult.totalPages || 0);
        setCurrentPage(paginatedResult.page || 0);

        setTimeout(() => gridApi?.current?.setRowData(rowData));
        gridOptions.rowSelection = 'multiple';
        gridOptions.columnDefs = columnDefs;
        gridOptions.rowData = rowData;

        gridOptions.pagination = false;
        gridOptions.domLayout = '';
        gridOptions.suppressRowClickSelection = true;

        gridOptions.onGridReady = (params) => {
          gridApi.current = params.api;
        };
        gridOptions.onSelectionChanged = (params) => {
          setSelectedNodes(
            params.api.getSelectedRows().map((e) => e?.questionId)
          );
          isValidUpdate(params.api.getSelectedRows());
        };
        gridOptions.suppressRowDeselection = true;
        gridOptions.isRowSelectable = (params) =>
          params.data.questionStatus !== 'APPROVED';
        setGridOptions(gridOptions);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  }, [selectedStatuses, filterSubject, filterStatus, filterComplexity, filterUpdatedBy, filterSearchText, pageSize]);

  // Re-fetch when statuses change — reset to page 0
  useEffect(() => {
    setCurrentPage(0);
    getQuestions(0, pageSize);
  }, [selectedStatuses]);

  // Re-fetch when column filters change — debounced, reset to page 0
  const filterInitialMount = useRef(true);
  useEffect(() => {
    if (filterInitialMount.current) {
      filterInitialMount.current = false;
      return;
    }
    if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
    filterDebounceRef.current = setTimeout(() => {
      setCurrentPage(0);
      getQuestions(0, pageSize);
    }, 400);
    return () => clearTimeout(filterDebounceRef.current);
  }, [filterSubject, filterStatus, filterComplexity, filterUpdatedBy, filterSearchText]);

  const handlePageChange = (newPage) => {
    if (newPage < 0 || newPage >= totalPages) return;
    setCurrentPage(newPage);
    getQuestions(newPage, pageSize);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(0);
    getQuestions(0, newSize);
  };

  let columnDefs = gridcolDef;
  gridcolDef.forEach((ele) => {
    if (ele?.field === fields.QUESTION_ID) {
      ele.cellRendererFramework = link;
      ele.cellStyle = (params) => {
        let obj = { background: '', color: 'black' };
        switch (params.data.questionStatus) {
          case questionStatuses.APPROVED:
            obj.background = '#19D2AC';
            return obj;
          case questionStatuses.SENT_FOR_APPROVAL:
            obj.background = 'yellow';
            return obj;
          case questionStatuses.SAVED:
            obj.background = obj.background = 'grey';
            return obj;
          case questionStatuses.CORRECTION_NEEDED:
            obj.background = '#FFB347';
            return obj;
          case questionStatuses.REJECTED:
            obj.background = '#ED3817';
            return obj;
          default:
            return {};
        }
      };
    }
    if (ele?.headerName === fields.ACTIONS) {
      ele.cellRendererFramework = button;
    }
  });

  const deleteQuestion = () => {
    deleteData(apiPaths.delete, {
      data: selectedNodes,
    })
      .then((res) => {
        setDisableButtons(
          JSON.parse(JSON.stringify(defaultDisableButtonsObject))
        );
        setSelectedNodes([]);
        getQuestions(currentPage, pageSize);
      })
      .catch((err) => console.log(err));
  };
  const isValidUpdate = (rows) => {
    if (rows.length == 0) {
      setDisableButtons(
        JSON.parse(JSON.stringify(defaultDisableButtonsObject))
      );
      return;
    }
    Object.keys(questionStatuses).forEach((qs) => {
      switch (questionStatuses[qs]) {
        case questionStatuses.SENT_FOR_APPROVAL:
          let invalidRowIds1 = rows
            .filter(
              (ele) => ele.questionStatus == questionStatuses.SENT_FOR_APPROVAL
            )
            .map((ele) => ele.questionId);
          let Message1 =
            'Questions[' +
            invalidRowIds1.join(',') +
            '] which are in Sent For Approval cannot be Sent For Approval';

          setDisableButtons((prev) => {
            let a = {};
            a[questionStatuses[qs]] = prev[questionStatuses[qs]];
            a[questionStatuses[qs]]['disable'] = invalidRowIds1.length != 0;
            a[questionStatuses[qs]]['Message'] = a[questionStatuses[qs]][
              'disable'
            ]
              ? Message1
              : '';
            return { ...prev, ...a };
          });
          break;
        case questionStatuses.APPROVED:
        case questionStatuses.CORRECTION_NEEDED:
        case questionStatuses.REJECTED:
          let invalidRowIds2 = rows
            .filter(
              (ele) => ele.questionStatus !== questionStatuses.SENT_FOR_APPROVAL
            )
            .map((ele) => ele.questionId);
          let Message2 =
            'Questions[' +
            invalidRowIds2.join(',') +
            '] which are not in Sent For Approval cannot be updated as ' +
            questionStatuses[qs];
          setDisableButtons((prev) => {
            let a = {};
            a[questionStatuses[qs]] = prev[questionStatuses[qs]];
            a[questionStatuses[qs]]['disable'] = invalidRowIds2.length != 0;
            a[questionStatuses[qs]]['Message'] = a[questionStatuses[qs]][
              'disable'
            ]
              ? Message2
              : '';
            return { ...prev, ...a };
          });
          break;
        default:
          return;
      }
    });
  };
  const updateQuestionStatus = (val) => {
    if (selectedNodes.length === 0) return;

    setDisplayAudit(false);
    setDisplayComments(true);
    status.current = val;
  };
  const onClickCommentsOk = () => {
    postData(apiPaths.updateQuestionStatus, {
      data: {
        "comment": comments && comments.length > 0 ? comments : '',
        "newStatus": status.current,
        "questionId": selectedNodes
      },
    })
      .then((val) => {
        comments = '';
        setDisplayComments(false);
        setSelectedNodes([]);
        setDisableButtons(
          JSON.parse(JSON.stringify(defaultDisableButtonsObject))
        );
        getQuestions(currentPage, pageSize);
      })
      .catch((err) => setDisplayComments(false));
  };
  const nav = (id, params) => {
    setEditQuestion(
      checkPermission('Dashboard', 'Add Question') &&
      params?.data?.questionStatus !== 'APPROVED'
    );
    if (id !== 0) {
      setQuestionIds((gridOptions.rowData || []).map((ele) => ele.questionId));
    }
    sessionStorage.setItem('routeFrom', 'dashboard')
    props.history.push('/app/question/' + id);
  };

  return loading ? (
    <PreLoader />
  ) : (
    <div className='dashboard-main-div'>
      <div className='main-heading'>Dashboard</div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="text"
          style={{ marginBottom: "2px" }}
          onClick={() => setDisplayCharts(!displayCharts)}
        >
          {" "}
          {displayCharts ? "hide" : "show"} chart
        </Button>
      </div>
      {displayCharts && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 16,
          marginBottom: 16,
        }}>
          {chartsData['Status'] && (
            <ChartCard title="Status" data={chartsData['Status']} chartType="donut" height={280} />
          )}
          {chartsData['Updated By'] && (
            <ChartCard title="Updated By" data={chartsData['Updated By']} height={280} />
          )}
          {chartsData['Complexity'] && (
            <ChartCard title="Complexity" data={chartsData['Complexity']} chartType="donut" height={280} />
          )}
          {chartsData['Created By'] && (
            <ChartCard title="Created By" data={chartsData['Created By']} height={280} />
          )}
        </div>
      )}

      <div className='background-common-div'>
        <div className='btn-div'>
          <div style={{ display: 'flex', paddingTop: '5px', float: 'left' }}>
            {Object.keys(questionStatuses).map((ele) => (
              <div
                key={ele}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  cursor: 'pointer',
                }}
                onClick={() => handleStatusClick(ele)}
              >
                <span
                  style={{
                    background: status_colors[ele],
                    border: '1px solid #000',
                    height: '16px',
                    width: '16px',
                    display: 'inline-block',
                  }}
                >
                  {selectedStatuses.includes(ele) && (
                    <span style={{ marginLeft: '0px' }}>✓</span>
                  )}
                </span>
                <span
                  style={{
                    background: 'white',
                    borderRadius: '22px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    paddingRight: '4px',
                    display: 'inline-block',
                    paddingLeft: '2px',
                    marginLeft: '8px',
                  }}
                  title={questionStatuses[ele]}
                >
                  {questionStatuses[ele]}
                </span>
              </div>
            ))}
          </div>
          <div style={{ paddingTop: '5px', float: 'right' }}>
            {checkPermission('Dashboard', 'Add Question') && (
              <button className='btn-common' onClick={() => nav(0)}>
                Add Question
              </button>
            )}
            {checkPermission('Dashboard', 'Upload Question') && (
              <button className='btn-common' onClick={() => props.history.push('/app/file/upload/0')}>
                Upload Question
              </button>
            )}
            {checkPermission('Dashboard', 'Sent For Approval') && (
              <button
                className='btn-common'
                onClick={() =>
                  updateQuestionStatus(questionStatuses.SENT_FOR_APPROVAL)
                }
                disabled={
                  disableButtons[questionStatuses.SENT_FOR_APPROVAL].disable
                }
                title={disableButtons[questionStatuses.SENT_FOR_APPROVAL].Message}
                data-toggle='modal'
                data-target='#myModal'
              >
                Send for Approval
              </button>
            )}
            {checkPermission('Dashboard', 'Approve') && (
              <button
                className='btn-common'
                data-toggle='modal'
                data-target='#myModal'
                onClick={() => updateQuestionStatus(questionStatuses.APPROVED)}
                disabled={disableButtons[questionStatuses.APPROVED].disable}
                title={disableButtons[questionStatuses.APPROVED].Message}
              >
                Approve
              </button>
            )}
            {checkPermission('Dashboard', 'Correction Needed') && (
              <button
                className='btn-common'
                onClick={() =>
                  updateQuestionStatus(questionStatuses.CORRECTION_NEEDED)
                }
                disabled={
                  disableButtons[questionStatuses.CORRECTION_NEEDED].disable
                }
                title={disableButtons[questionStatuses.CORRECTION_NEEDED].Message}
                data-toggle='modal'
                data-target='#myModal'
              >
                Correction Needed
              </button>
            )}
            {checkPermission('Dashboard', 'Reject') && (
              <button
                className='btn-common'
                onClick={() => updateQuestionStatus(questionStatuses.REJECTED)}
                disabled={disableButtons[questionStatuses.REJECTED].disable}
                title={disableButtons[questionStatuses.REJECTED].Message}
                data-toggle='modal'
                data-target='#myModal'
              >
                Reject
              </button>
            )}
            {checkPermission('Dashboard', 'Delete') && (
              <button
                className='btn-common'
                onClick={deleteQuestion}
                disabled={selectedNodes.length === 0}
              >
                Delete
              </button>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px', padding: '10px 0', flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField
            size="small"
            label="Search Question"
            variant="outlined"
            value={filterSearchText}
            onChange={(e) => setFilterSearchText(e.target.value)}
            style={{ minWidth: '180px' }}
          />
          <select
            value={filterSubject}
            onChange={(e) => setFilterSubject(e.target.value)}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minWidth: '160px', height: '40px' }}
          >
            <option value="">All Subjects</option>
            {filterBySubjectScope(subjects || [], (s) => s.subjectId).map((sub) => (
              <option key={sub.subjectId} value={sub.subjectId}>{sub.subject}</option>
            ))}
          </select>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minWidth: '160px', height: '40px' }}
          >
            <option value="">All Statuses</option>
            {Object.values(questionStatuses).map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
          <TextField
            size="small"
            label="Complexity"
            variant="outlined"
            value={filterComplexity}
            onChange={(e) => setFilterComplexity(e.target.value)}
            style={{ width: '130px' }}
          />
          <TextField
            size="small"
            label="Updated By"
            variant="outlined"
            value={filterUpdatedBy}
            onChange={(e) => setFilterUpdatedBy(e.target.value)}
            style={{ width: '150px' }}
          />
          <button
            className='btn-common'
            onClick={() => {
              setFilterSearchText('');
              setFilterSubject('');
              setFilterStatus('');
              setFilterComplexity('');
              setFilterUpdatedBy('');
            }}
            style={{ height: '40px' }}
          >
            Clear Filters
          </button>
        </div>

        <div className='common-div-alt'>
          <Grid gridOptions={gridOptions} parent="dashboard" />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>Rows per page:</span>
            <select
              value={pageSize}
              onChange={(e) => handlePageSizeChange(Number(e.target.value))}
              style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc' }}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span style={{ marginLeft: '10px', color: '#666' }}>
              Total: {totalRecords} records
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button
              className='btn-common'
              onClick={() => handlePageChange(0)}
              disabled={currentPage === 0}
              style={{ padding: '4px 10px' }}
            >
              First
            </button>
            <button
              className='btn-common'
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 0}
              style={{ padding: '4px 10px' }}
            >
              Prev
            </button>
            <span>
              Page {totalPages > 0 ? currentPage + 1 : 0} of {totalPages}
            </span>
            <button
              className='btn-common'
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              style={{ padding: '4px 10px' }}
            >
              Next
            </button>
            <button
              className='btn-common'
              onClick={() => handlePageChange(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              style={{ padding: '4px 10px' }}
            >
              Last
            </button>
          </div>
        </div>
      </div>

      <div
        id='myModal'
        class='modal fade show'
        role='dialog'
        style={{ display: displayComments || displayAudit ? 'block' : '' }}
      >
        <div class='modal-dialog modal-dialog-custom'>
          <div class='modal-content'>
            <div class='modal-header modal-header-custom'>
              <button
                type='button'
                class='close'
                data-dismiss='modal'
                onClick={() => {
                  setDisplayComments(false);
                  setDisplayAudit(false);
                }}
              >
                <div class='close-btn'>
                  <i class='fa fa-close' aria-hidden='true'></i>
                </div>
              </button>
            </div>
            <div class='modal-body modal-body-custom'>
              {displayComments ? (
                <div class='comments-div'>
                  <div class='comments-text-div'>Add comments</div>
                  <textarea
                    class='textarea-custom'
                    onChange={($event) => (comments = $event.target.value)}
                    value={comments}
                  ></textarea>
                  <button
                    class='btn-common float-right'
                    onClick={() => onClickCommentsOk()}
                    data-dismiss='modal'
                  >
                    OK
                  </button>
                </div>
              ) : (
                ''
              )}
              {displayAudit ? (
                <div style={{ height: '100%' }}>
                  <Grid gridOptions={auditGridOptions} parent="dashboard" />
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
